import { useCallback, useEffect, useState } from 'react';
import { FlowArrow } from '@phosphor-icons/react';
import { Badge } from '@/components/ui/badge';
import { formatJST } from '@/utils/datetime';
import { flowApi } from './itemFlowApi';

const STATUS_BADGE = {
  draft: 'text-zinc-500 border-zinc-200', items_assigned: 'text-sky-600 border-sky-200',
  in_progress: 'text-amber-600 border-amber-200', output_created: 'text-teal-600 border-teal-200',
  pending_decision: 'text-violet-600 border-violet-200',
  transferred_equipment: 'text-indigo-600 border-indigo-200',
  transferred_sellable: 'text-emerald-600 border-emerald-200',
  scrapped: 'text-rose-600 border-rose-200', closed: 'text-zinc-400 border-zinc-200',
};

// プロジェクトページ内に表示する旧アイテムフローの一覧。
// 旧アイテムフローの画面は撤去したので、行は遷移しない（過去データの要約表示のみ）。
// 一覧そのものは残す — 消すと「この案件に過去フローがあった事実」が見えなくなるため。
export default function ProjectFlowsPanel({ projectId }) {
  const [flows, setFlows] = useState(null);

  const load = useCallback(() => {
    flowApi.list({ project_id: projectId }).then(setFlows).catch(() => setFlows([]));
  }, [projectId]);
  useEffect(() => { load(); }, [load]);

  if (flows !== null && flows.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-zinc-200 p-5 shadow-sm space-y-3" data-testid="project-flows-panel">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-sm font-semibold text-zinc-800 flex items-center gap-1.5">
          <FlowArrow size={16} weight="duotone" className="text-zinc-500" /> 旧アイテムフロー
        </p>
        <p className="text-[11px] text-zinc-400">過去データの記録のみ（新しい開発は開発案件管理へ）</p>
      </div>
      {flows === null ? (
        <p className="text-[12px] text-zinc-400">読み込み中…</p>
      ) : (
        <div className="space-y-1.5">
          {flows.map((f) => (
            <div key={f.id} className="w-full flex items-center gap-2 rounded-lg border border-zinc-200 px-3 py-2"
              data-testid={`project-flow-${f.id}`}>
              <span className="min-w-0 flex-1">
                <span className="block text-[13px] font-medium text-zinc-800 truncate">{f.flow_name}</span>
                <span className="block text-[10px] text-zinc-400">
                  部品 {f.component_count} · 成果品 {f.output_count} · 最終処遇: {f.outcome_label} · {formatJST(f.updated_at)}
                </span>
              </span>
              <Badge variant="outline" className={`text-[10px] shrink-0 ${STATUS_BADGE[f.status] || ''}`}>{f.status_label}</Badge>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
